import { createNewsService } from '@radevents/shared';
import api from './api';

export const newsService = createNewsService(api);
export default newsService;
